module.exports = __webpack_public_path__ + "static/img/01055A_1_V_20201120_LC.804d066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01055A_1_V_20201120_LC.png
// module id = VV6Q
// module chunks = 0